var isIE = ua.indexOf("msie") > -1;
if (typeof Object.assign != "function") {
  Object.assign = function (target) {
    "use strict";
    if (target == null) {
      throw new TypeError("Cannot convert undefined or null to object");
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
  // function addEventListener(ele, event, fn) {
  //   if (isIE) {
  //     ele.addEventListener(event, fn, false);
  //   } else {
  //     ele.attachEvent("on" + event, fn.bind(ele));
  //   }
  // }
  // window.addEventListener = addEventListener;
}



//////////////////
// WEBPACK FOOTER
// ./src/utiles/ie.js
// module id = 31
// module chunks = 0